module.exports = __webpack_public_path__ + "static/media/date.4fdf9765.svg";